let globals = window || this || {};
require('@medscape/streaming-video-player/amp-premier/akamai/amp/core/amp.js');
require('@medscape/streaming-video-player/amp-premier/akamai/amp/react/libs/react.js');
require('@medscape/streaming-video-player/amp-premier/akamai/amp/react/React.js');
require('@medscape/streaming-video-player/amp-premier/akamai/amp/core/libs/hls.js');
require('@medscape/streaming-video-player/amp-premier/akamai/amp/core/amp.css');
require('@medscape/streaming-video-player/amp-premier/akamai/amp/react/React.css');

const { AppMeasurement, akamai } = globals;

let { AMP } = akamai.amp;

const url = new URL(document.location.href);
const { searchParams } = url;
const debugParam = searchParams.get("svp-debug");
const allowLog = debugParam != null;

export default globals;
export { AMP }
export { akamai }
export { AppMeasurement }
export { allowLog }

